import { useControlPanelState as useControlPanelStateBase } from "@atlas-int/controls";
import { useCurrentVizType } from "../../routing/typedRoutes";
import { googleAnalyticsCustomEvent } from "../../sharedUtilities/analytics";
import { ControlPanelRouter } from "./panels";

export default function ControlsPanel() {
  const vizType = useCurrentVizType();

  const { isSettingsOpen, toggleSettingsPanel } =
    useControlPanelStateBase({
      vizType,
      onSettingsOpen: () =>
        googleAnalyticsCustomEvent("menu", "open", "settings", "explore"),
    });

  return (
    <ControlPanelRouter
      vizType={vizType}
      isSettingsOpen={isSettingsOpen}
      toggleSettingsPanel={toggleSettingsPanel}
    />
  );
}
